export default __webpack_public_path__ + "static/img-baker-kevin-chou-5f078fb428875a0a703a688f608e4871.png";